import { Plugin } from 'ckeditor5';
import {
  ImportWordEditing,
  type ImportWordDataInsertEvent,
  type ImportWordDataInsertEventData,
} from 'ckeditor5-premium-features';

import {
  fitTablesToTextWidth,
  parseHTMLString,
  removeNegativeMarginLeft,
  removeTablePxWidths,
} from '../../util/HTMLElementUtils';

type ImportWordPageLayout = {
  document_size?: { width: number };
  document_margins?: { left: number; right: number };
};

const getTextWidth = ({
  document_size,
  document_margins,
}: ImportWordPageLayout) =>
  document_size && document_margins
    ? document_size.width - document_margins.left - document_margins.right
    : undefined;

export class QualioImportWordPlugin extends Plugin {
  static get pluginName(): string {
    return 'QualioImportWordPlugin';
  }

  static get requires() {
    return [ImportWordEditing] as const;
  }

  static handleDataInsert(
    data: ImportWordDataInsertEventData & ImportWordPageLayout,
  ) {
    const parsedHTML = parseHTMLString(data.html);
    const textWidth = getTextWidth(data);
    if (textWidth) {
      fitTablesToTextWidth(parsedHTML, textWidth);
    } else {
      removeTablePxWidths(parsedHTML);
    }
    removeNegativeMarginLeft(parsedHTML);
    data.html = parsedHTML.body.innerHTML;
  }

  init(): void {
    this.editor.commands
      .get('importWord')!
      .on<ImportWordDataInsertEvent>('dataInsert', (_evt, data) => {
        QualioImportWordPlugin.handleDataInsert(data);
      });
  }
}
